import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import SliderProducts from "./SliderProducts";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";

export default function ({register, errors, control, data, setData, watch}) {

  return (<>
    <TextInput
      label="Name"
      name="name"
      className="col-md-12 col-sm-6"
      register={register}
      required={true}
      errorMessage={errors?.name}
    />

    <ReactSelectInput
      label="Page"
      name="page"
      className="col-md-12 col-sm-12 pt-3"
      options={data?.pages}
      control={control}
      errorMessage={errors?.page}
      required={true}
    />

    <ReactMultiSelectInput
      label="Categories"
      name="categories"
      placeholder="Choose Categories"
      parentClasses="pb-4"
      inputClassName="col-md-6"
      register={register}
      values={data?.categories}
      errorMessage={errors?.categories}
      control={control}
    />

    <TextInput
      label="Position"
      name="position"
      parentClasses="col-md-12 col-sm-12 mt-4"
      register={register}
      errorMessage={errors?.position}
    />

    <SliderProducts
      register={register}
      control={control}
      watch={watch}
      errors={errors}
      data={data}
      setData={setData}
    />
  </>);
}